import React from 'react';
import { Row, Col, Typography } from 'antd';
import { Pie } from '@ant-design/charts';
const { Title } = Typography;

const config = {
  angleField: 'y',
  colorField: 'x',
  innerRadius: 0.85,
  label: false,
  legend: false,
  tooltip: false,
  scale: {
    color: {
        range: ['red', 'blue']
    }
  },
  annotations: [
    {
      type: 'text',
      style: {
        text: '',
        x: '50%',
        y: '45%',
        textAlign: 'center',
        fontSize: 12,
        fontStyle: 'bold',
      },
      tooltip: false
    },
    {
      type: 'text',
      style: {
        text: '',
        x: '50%',
        y: '55%',
        textAlign: 'center',
        fontSize: 12,
        fontStyle: 'bold',
      },
      tooltip: false
    },
  ],
};

const DonutChart =  ({ cdata }) => {
  const dataArray = cdata.dataArray;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <Title level={2} style={{ textAlign: 'center' }}>
        {cdata.title}
      </Title>
      <Row gutter={40} justify="center">
        { dataArray.map((item, index) => {
          const cg = JSON.parse(JSON.stringify(config));
          cg.annotations[0].style.text = item.ctext1 + "%";
          cg.annotations[1].style.text = item.ctext2;
          cg.data = item.data;
          if(index % 2 == 0) {
            cg.scale.color.range[0] = '#99E9BA';
            cg.scale.color.range[1] = '#00C752';
          } else {
            cg.scale.color.range[0] = '#FFDEA6';
            cg.scale.color.range[1] = '#FFAD20';
          }
          return (<Col span={Math.round(24/dataArray.length)} style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{width: '200px', height: '200px'}}>
              <Pie {...cg} />
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: '#555' }}>{item.btext}</div>
              </div> 
            </div>
          </Col>);
        })}
      </Row>
      {/* <div style={{width: '150px', height: '150px'}}>
        <Pie {...config} />
      </div>
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{middleText}</div>
        <div style={{ fontSize: '12px', color: '#555' }}>{bottomText}</div>
      </div> */}
    </div>
  );
};


export default DonutChart;